/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

import Dialog from 'material-ui/Dialog/Dialog';
import DialogContent from 'material-ui/Dialog/DialogContent';
import DialogContentText from 'material-ui/Dialog/DialogContentText';
import DialogTitle from 'material-ui/Dialog/DialogTitle';

import GoogleMapReact from 'google-map-react';
import { fitBounds } from 'google-map-react/utils';
import { getMapOptions } from '../AssetConsuming/mapHelper';
import Tooltip from 'material-ui/Tooltip';
import Place from 'material-ui-icons/Place';

import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { FormGroup, FormControlLabel } from 'material-ui/Form';

import BlueSwitch from '../commons/BlueSwitch';
import DatesSlider from '../commons/DatesSlider';
import PercentageSlider from '../commons/PercentageSlider';
import DistanceSlider from '../commons/DistanceSlider';
import AssetsList from '../commons/AssetsList';
import { CSSTransitionGroup } from 'react-transition-group';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { assets } from '../../assets/';

import { enums } from '../../enums/';

import Card, { CardHeader, CardContent, CardMedia } from 'material-ui/Card';
import Grid from 'material-ui/Grid';
import { Row, Col } from 'react-flexbox-grid';

import Typography from 'material-ui/Typography';

import { withRouter } from 'react-router';
import settingsIcon from '../../assets/images/icons/settings.png';

import Button from 'material-ui/Button';
import { translate } from 'react-i18next';

//Start Drag and Drop functions
// fake data generator
const getItems = count =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k}`,
    content: `item ${k}`,
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: '6px 12px',
  margin: `0 0 1px 0`,

  // change background colour if dragging
  background: isDragging ? 'rgb(0, 170, 255, 0.6)' : 'white',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = isDraggingOver => ({
  background: isDraggingOver
    ? 'rgb(224, 224, 224, 0.4)'
    : 'rgb(224, 224, 224, 1)',
  padding: 1,
  width: '100%',
});
//End Drag and Drop functions

/**
 * Common component import
 */
import LoadingCircle from '../commons/LoadingCircle';

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'center',
  },
  margin: {
    margin: theme.spacing.unit,
  },
  withoutLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
});

class OrganizationPreferences extends React.Component {
  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      volume: 0,
      displaySpecificAssets: false,
      dialogPreferencesOpen: false,
      loadingAssetsList: false,
      displayedAsset: null,
      selectedAssets: [],
      prodAssetsList: [
        {
          assetType: 3,
          assetTypeName: 'Mes actifs',
          assetTypeIcon: assets.images.factoryMapIcon2,
        },
        {
          assetType: 0,
          assetTypeName: 'Eolien',
          assetTypeIcon: assets.images.windTurbineMapIcon2,
        },
        {
          assetType: 1,
          assetTypeName: 'Solaire',
          assetTypeIcon: assets.images.solarPanelMapIcon2,
        },
        {
          assetType: 2,
          assetTypeName: 'Hydraulique',
          assetTypeIcon: assets.images.damMapIcon2,
        },
      ],
      currentAssetConsuming: {
        _id: '5c2ccd84e7179a49f40b00e1',
        id: 0,
        ownerId: 1,
        smireName: 'lida_rte',
        test: 'test',
        name: 'Hôtel de ville',
        consumptionPercentage: 1,
        operationalSince: 1526283576,
        capacity: 12345,
        maxGooContract: 60000000000.0,
        producingAssets: [
          {
            _id: '5d1a4015d05eea46f7939e21',
            id: 6,
            priority: 2,
            percentage: 50,
          },
          {
            _id: '5d1a4015d05eea46f7939e20',
            id: 1,
            priority: 1,
            percentage: 50,
          },
          {
            _id: '5d1a4015d05eea46f7939e1f',
            id: 0,
            priority: 0,
            percentage: 50,
          },
        ],
        maxGooContractByAsset: [
          {
            producingAssets: [1],
            _id: '5cb6e5f28df9c9677a654c3e',
            maxGoo: 10000000000.0,
            year: 2018,
          },
          {
            producingAssets: [0, 2],
            _id: '5cb6e5f28df9c9677a654c3d',
            maxGoo: 50000000000.0,
            year: 2018,
          },
        ],
        smartMeter: '0x00dEb90C67B8953F6Dc4a5DB3bb2Bd6aB3BC2B3E',
        owner: '0x0051CcCBCFF51788dDa9614b12dcea0D57208C03',
        maxCapacitySet: true,
        lastSmartMeterReadWh: 123,
        certificatesUsedForWh: 10,
        active: true,
        country: 'France',
        region: 'Ile de France',
        zip: '75001',
        city: 'Paris',
        street: "Place de l'hôtel de ville",
        houseNumber: '',
        lastSmartMeterReadFileHash: 'fileHash',
        gpsLatitude: 48.85667,
        gpsLongitude: 2.352253,
        avoidedCo2: 4567,
        matchingPercentage: '1',
        assetID: 'LIDA',
        source: 'DEMO',
        sourceID: 'DEMO',
        displayedName: 'Hôtel de ville',
        displayPercentage: '1',
        periodNumber: 1,
        periodType: 'hour',
        aggregationPeriodType: 'day',
        aggregationPeriodNumber: 1,
        momentTimezone: 'Europe/Paris',
        sourceHistory: [],
        organization: '5d415c1bbd95d238b2593c6c',
      },
      producingAssets: [
        {
          _id: '5c2cd043e7179a49f40b02dd',
          percentage: 3,
          price: 2,
          id: 0,
          active: true,
          cO2UsedForCertificate: 0,
          capacityWh: 155000000,
          certificatesCreatedForWh: 12950327175,
          city: 'Liginiac',
          country: 'France',
          displayedName: 'Marèges',
          gpsLatitude: 45.391667,
          gpsLongitude: 2.36416699999995,
          houseNumber: '',
          lastSmartMeterCO2OffsetRead: 0,
          lastSmartMeterReadFileHash:
            '0x31353436343236343530313838756e646566696e656400000000000000000000',
          lastSmartMeterReadWh: 1222028414918,
          name: 'plt_mareges',
          operationalSince: '1982-01-01T04:00:00.000Z',
          otherGreenAttributes: 'OGA5',
          owner: '0x0029ab4DFCEf587Bb80e8b66d89aE44F4827F747',
          region: 'Nouvelle-Aquitaine',
          registryCompliance: 3,
          smartMeter: '0x00CB17ea4DfA8578582C00A79Dd92d6111c28c54',
          street: '',
          typeOfPublicSupport: 'TyPS5',
          zip: '19160',
          charteFilename: 'charte_rse.pdf',
          certifications: [
            {
              logoName: 'Afaq_45001_g.png',
              title: 'Certification AFAQ 45001',
              url:
                'https://certification.afnor.org/en/risk-management-ohs/iso-45001-certification',
            },
            {
              logoName: 'Afaq_14001_g.png',
              title: 'Certification AFAQ 14001',
              url:
                'https://certification.afnor.org/environnement/certification-afaq-14001-par-etapes',
            },
            {
              logoName: 'logo_lucie1.png',
              title: 'Label RSE LUCIE',
              url: 'https://www.labellucie.com/',
            },
          ],
          assetType: 2,
          assetID: 'MAREGES',
          source: 'DEMO',
          sourceID: 'DEMO',
          periodNumber: 10,
          periodType: 'minute',
          momentTimezone: 'Europe/Paris',
          sourceHistory: [],
          aggregationPeriodNumber: 1,
          aggregationPeriodType: 'day',
          organization: '5d430c4e3683662aab2c61c9',
        },
        {
          _id: '5c2cd054e7179a49f40b02f0',
          id: 1,
          percentage: 10,
          price: 2,
          active: true,
          cO2UsedForCertificate: 0,
          capacityWh: 7800000,
          certificatesCreatedForWh: 5468534072,
          city: 'Brusque',
          country: 'France',
          gpsLatitude: 43.761234,
          gpsLongitude: 2.902555,
          houseNumber: '',
          lastSmartMeterCO2OffsetRead: 0,
          lastSmartMeterReadFileHash:
            '0x31353436343236343532323539756e646566696e656400000000000000000000',
          lastSmartMeterReadWh: 2011745093316,
          operationalSince: '1970-01-01T03:00:00.000Z',
          otherGreenAttributes: 'NA',
          owner: '0x0029ab4DFCEf587Bb80e8b66d89aE44F4827F747',
          region: 'Occitanie',
          registryCompliance: 3,
          smartMeter: '0x00c3B44DBeA6f103dd30D7e90D59787175FeA185',
          street: 'Merdelou-Fontanelles',
          assetType: 4,
          typeOfPublicSupport: 'NA',
          zip: '12360',
          name: 'fontanelles',
          displayedName: 'Wind 1',
          certifications: [
            {
              logoName: 'Afaq_9001_g.png',
              title: 'Certification AFAQ 9001',
              url:
                'https://certification.afnor.org/qualite/certification-afaq-iso-9001',
            },
            {
              logoName: 'Afaq_14001_g.png',
              title: 'Certification AFAQ 14001',
              url:
                'https://certification.afnor.org/environnement/certification-afaq-14001-par-etapes',
            },
          ],
          assetID: 'FONTANELLES',
          source: 'DEMO',
          sourceID: 'DEMO',
          periodNumber: 10,
          periodType: 'minute',
          momentTimezone: 'Europe/Paris',
          sourceHistory: [],
          aggregationPeriodNumber: 1,
          aggregationPeriodType: 'day',
          organization: '5d430c4e3683662aab2c61c9',
        },
        {
          _id: '5c2cd067e7179a49f40b02f2',
          id: 2,
          percentage: 20,
          price: 2,
          active: true,
          cO2UsedForCertificate: 0,
          capacityWh: 39000000,
          certificatesCreatedForWh: 22645905364,
          city: 'Saint-Lary-Soulan',
          country: 'France',
          gpsLatitude: 42.8331477,
          gpsLongitude: 0.199851500000022,
          houseNumber: 'Eget',
          lastSmartMeterCO2OffsetRead: 0,
          lastSmartMeterReadFileHash:
            '0x31353436343236343634343031756e646566696e656400000000000000000000',
          lastSmartMeterReadWh: 22633559599065,
          operationalSince: '1970-01-01T03:00:00.000Z',
          otherGreenAttributes: 'N/A',
          owner: '0x0029ab4DFCEf587Bb80e8b66d89aE44F4827F747',
          region: 'Occitanie',
          registryCompliance: 3,
          smartMeter: '0x004A064a9AAf2fCD9687D82Fc5a1116e9325000A',
          street: "Réservoir de l'Oule",
          assetType: 2,
          typeOfPublicSupport: 'N/A',
          zip: '65170',
          name: 'eget',
          displayedName: 'HydroSmall',
          charteFilename: 'charte_rse.pdf',
          certifications: [
            {
              logoName: 'Afaq_45001_g.png',
              title: 'Certification AFAQ 45001',
              url:
                'https://certification.afnor.org/en/risk-management-ohs/iso-45001-certification',
            },
            {
              logoName: 'Afaq_14001_g.png',
              title: 'Certification AFAQ 14001',
              url:
                'https://certification.afnor.org/environnement/certification-afaq-14001-par-etapes',
            },
            {
              logoName: 'logo_lucie1.png',
              title: 'Label RSE LUCIE',
              url: 'https://www.labellucie.com/',
            },
          ],
          assetID: 'EGET',
          source: 'DEMO',
          sourceID: 'DEMO',
          periodNumber: 10,
          periodType: 'minute',
          momentTimezone: 'Europe/Paris',
          sourceHistory: [],
          aggregationPeriodNumber: 1,
          aggregationPeriodType: 'day',
          organization: '5d430c4e3683662aab2c61c9',
        },
        {
          _id: '5c6d13dde77fa60a2afaa1fa',
          id: 3,
          percentage: 30,
          price: 2,
          houseNumber: '',
          street: '',
          zip: '15190',
          city: 'Saint-Amandin',
          region: 'Auvergne-Rhône-Alpes',
          country: 'France',
          gpsLatitude: 45.343545,
          gpsLongitude: 2.69498999999996,
          owner: '0x0029ab4DFCEf587Bb80e8b66d89aE44F4827F747',
          smartMeter: '0x00644E4A9b3Ac9Ab4544314c085B525c80311eD3',
          name: 'plt_coindre',
          displayedName: 'HydroAsset',
          capacityWh: 36000000,
          otherGreenAttributes: 'N/A',
          typeOfPublicSupport: 'N/A',
          assetType: 2,
          registryCompliance: 3,
          operationalSince: '1978-01-01T04:00:00.000Z',
          active: true,
          charteFilename: 'charte_rse.pdf',
          certifications: [
            {
              logoName: 'Afaq_45001_g.png',
              title: 'Certification AFAQ 45001',
              url:
                'https://certification.afnor.org/en/risk-management-ohs/iso-45001-certification',
            },
            {
              logoName: 'Afaq_14001_g.png',
              title: 'Certification AFAQ 14001',
              url:
                'https://certification.afnor.org/environnement/certification-afaq-14001-par-etapes',
            },
            {
              logoName: 'logo_lucie1.png',
              title: 'Label RSE LUCIE',
              url: 'https://www.labellucie.com/',
            },
          ],
          __v: 0,
          assetID: 'COINDRE',
          source: 'DEMO',
          sourceID: 'DEMO',
          periodNumber: 10,
          periodType: 'minute',
          momentTimezone: 'Europe/Paris',
          sourceHistory: [],
          aggregationPeriodNumber: 1,
          aggregationPeriodType: 'day',
          organization: '5d430c4e3683662aab2c61c9',
        },
        {
          _id: '5c6d1557e77fa60a2afaa1fb',
          id: 4,
          percentage: 24,
          price: 2,
          houseNumber: '',
          street: '',
          zip: '65260',
          city: 'Soulom',
          region: 'Occitanie',
          country: 'France',
          gpsLatitude: 42.956895,
          gpsLongitude: -0.0744009999999662,
          owner: '0x0029ab4DFCEf587Bb80e8b66d89aE44F4827F747',
          smartMeter: '0x004888bAc67F185AF581D4F3CA5BB665e6Fd9c52',
          name: 'plt_soulom_bc',
          displayedName: 'HydroMountain1',
          capacityWh: 32000000,
          otherGreenAttributes: 'N/A',
          typeOfPublicSupport: 'N/A',
          assetType: 2,
          registryCompliance: 3,
          operationalSince: '2019-01-01T03:00:00.000Z',
          active: true,
          charteFilename: 'charte_rse.pdf',
          certifications: [
            {
              logoName: 'Afaq_45001_g.png',
              title: 'Certification AFAQ 45001',
              url:
                'https://certification.afnor.org/en/risk-management-ohs/iso-45001-certification',
            },
            {
              logoName: 'Afaq_14001_g.png',
              title: 'Certification AFAQ 14001',
              url:
                'https://certification.afnor.org/environnement/certification-afaq-14001-par-etapes',
            },
            {
              logoName: 'logo_lucie1.png',
              title: 'Label RSE LUCIE',
              url: 'https://www.labellucie.com/',
            },
          ],
          __v: 0,
          assetID: 'SOULOM-BC',
          source: 'DEMO',
          sourceID: 'DEMO',
          periodNumber: 10,
          periodType: 'minute',
          momentTimezone: 'Europe/Paris',
          sourceHistory: [],
          aggregationPeriodNumber: 1,
          aggregationPeriodType: 'day',
          organization: '5d430c4e3683662aab2c61c9',
        },
        {
          _id: '5c6d1656e77fa60a2afaa1fc',
          id: 5,
          percentage: 5,
          price: 2,
          houseNumber: '',
          street: '',
          zip: '65260',
          city: 'Soulom',
          region: 'Occitanie',
          country: 'France',
          gpsLatitude: 42.956895,
          gpsLongitude: -0.0744009999999662,
          owner: '0x0029ab4DFCEf587Bb80e8b66d89aE44F4827F747',
          smartMeter: '0x0040A818292B8CF7eDd60A99cd7BAcCECf7f4F23',
          name: 'plt_soulom_hc',
          displayedName: 'HydroLake',
          capacityWh: 19000000,
          otherGreenAttributes: 'N/A',
          typeOfPublicSupport: 'N/A',
          assetType: 2,
          registryCompliance: 3,
          operationalSince: '2019-01-01T03:00:00.000Z',
          active: true,
          charteFilename: 'charte_rse.pdf',
          certifications: [
            {
              logoName: 'Afaq_45001_g.png',
              title: 'Certification AFAQ 45001',
              url:
                'https://certification.afnor.org/en/risk-management-ohs/iso-45001-certification',
            },
            {
              logoName: 'Afaq_14001_g.png',
              title: 'Certification AFAQ 14001',
              url:
                'https://certification.afnor.org/environnement/certification-afaq-14001-par-etapes',
            },
            {
              logoName: 'logo_lucie1.png',
              title: 'Label RSE LUCIE',
              url: 'https://www.labellucie.com/',
            },
          ],
          __v: 0,
          assetID: 'SOULOM-HC',
          source: 'DEMO',
          sourceID: 'DEMO',
          periodNumber: 10,
          periodType: 'minute',
          momentTimezone: 'Europe/Paris',
          sourceHistory: [],
          aggregationPeriodNumber: 1,
          aggregationPeriodType: 'day',
          organization: '5d430c4e3683662aab2c61c9',
        },
        {
          _id: '5d1a4015d05eea46f7939e1e',
          id: 6,
          percentage: 17,
          price: 2,
          active: true,
          capacityWh: 82000000,
          city: 'Gréoux-les-Bains',
          country: 'France',
          displayedName: 'MySolar',
          gpsLatitude: 43.778089,
          gpsLongitude: 5.818016,
          houseNumber: '',
          name: 'my_solar',
          operationalSince: '2019-07-01T01:17:09.000Z',
          owner: '0x0029ab4DFCEf587Bb80e8b66d89aE44F4827F747',
          region: 'Occitanie',
          registryCompliance: 0,
          street: 'D4',
          zip: '04800',
          assetType: 1,
          assetID: 'MY-SOLAR',
          source: 'DEMO',
          sourceID: 'DEMO',
          periodNumber: 1,
          periodType: 'day',
          momentTimezone: 'Europe/Paris',
          sourceHistory: [],
          aggregationPeriodNumber: 1,
          aggregationPeriodType: 'day',
          __v: 0,
          organization: '5d430c4e3683662aab2c61c9',
        },
      ],
    };
    this.onDragEnd = this.onDragEnd.bind(this);
    this.setMapBounds = this.setMapBounds.bind(this);
    this.renderAssetsType = this.renderAssetsType.bind(this);
  }

  componentDidMount = async () => {};

  onDrop = async file => {
    this.props.uploadOrganizationPicture(
      file,
      this.props.currentOrganization.id
    );
  };

  renderMap(defaultCenter, center, zoom) {
    const currentAssetConsuming = this.state.currentAssetConsuming;
    const assetConsumingLat = 48.880343;
    const assetConsumingLng = 2.325582;
    const producingAssets = this.state.producingAssets;

    return (
      <GoogleMapReact
        ref={ref => {
          this.map = ref;
        }}
        bootstrapURLKeys={{ key: 'AIzaSyBleDoIxwGmKTDHbxeaMFo-ny5e-xEPoNs' }}
        defaultZoom={zoom}
        defaultCenter={defaultCenter}
        center={center}
        zoom={zoom}
        onGoogleApiLoaded={this.onMapLoaded}
        yesIWantToUseGoogleMapApiInternals
        options={getMapOptions}
      >
        <div
          lat={assetConsumingLat}
          lng={assetConsumingLng}
          text={
            currentAssetConsuming.name
              ? currentAssetConsuming.name
              : currentAssetConsuming.city
          }
        >
          <Tooltip
            title={
              currentAssetConsuming.name
                ? currentAssetConsuming.name
                : currentAssetConsuming.city
            }
          >
            <div>
              <Place
                style={{
                  color: '#607D8B',
                  fontSize: 52,
                  position: 'absolute',
                  top: -40,
                  left: -21,
                }}
              />
              <img
                src={assets.images.factoryMapIcon2}
                style={{
                  maxHeight: 19,
                  marginLeft: 19,
                  marginRight: 19,
                  marginBottom: -4,
                  position: 'absolute',
                  top: -30,
                  left: -23,
                }}
              />
            </div>
          </Tooltip>
        </div>
        {this.renderProducingAssetsOnMap(producingAssets)}
      </GoogleMapReact>
    );
  }

  selectAsset(selectedAsset) {
    console.log('selectAsset... ');
    console.log(this.state.selectedAssets);
    let selectedAssets = this.state.selectedAssets.map(asset => asset);
    selectedAssets.push(selectedAsset);
    console.log('selectedAssets', selectedAssets);

    this.setState({ selectedAssets });
    console.log(this.state.selectedAssets);
  }

  setMapBounds(map, mapContainer, googleMap, googleMaps) {
    const currentAssetConsuming = this.state.currentAssetConsuming;
    const assetsProducing = this.state.producingAssets;

    const assetConsumingLat =
      currentAssetConsuming && currentAssetConsuming.gpsLatitude
        ? parseFloat(currentAssetConsuming.gpsLatitude)
        : 48.880343;
    const assetConsumingLng =
      currentAssetConsuming && currentAssetConsuming.gpsLongitude
        ? parseFloat(currentAssetConsuming.gpsLongitude)
        : 2.325582;

    const bounds = new window.google.maps.LatLngBounds();

    bounds.extend(
      new window.google.maps.LatLng(assetConsumingLat, assetConsumingLng)
    );

    if (assetsProducing && assetsProducing.length > 0) {
      assetsProducing.map((asset, i) => {
        bounds.extend(
          new window.google.maps.LatLng(
            parseFloat(asset.gpsLatitude),
            parseFloat(asset.gpsLongitude)
          )
        );

        //add a polyline on the map from consuming asset to production asset

        const polylineCoordinates = [
          { lat: assetConsumingLat, lng: assetConsumingLng },
          {
            lat: parseFloat(asset.gpsLatitude),
            lng: parseFloat(asset.gpsLongitude),
          },
        ];

        const lineSymbol = {
          path: 'M 0,-1 0,1',
          strokeOpacity: 0.8,
          scale: 2,
        };

        const polylinePath = new window.google.maps.Polyline({
          path: polylineCoordinates,
          geodesic: true,
          strokeColor: '#21453C',
          strokeOpacity: 0,
          strokeWeight: 2,
          icons: [
            {
              icon: lineSymbol,
              offset: '0',
              repeat: '10px',
            },
          ],
        });

        polylinePath.setMap(googleMap);
      });
    }

    const newBounds = {
      ne: {
        lat: bounds.getNorthEast().lat(),
        lng: bounds.getNorthEast().lng(),
      },
      sw: {
        lat: bounds.getSouthWest().lat(),
        lng: bounds.getSouthWest().lng(),
      },
    };

    const size = {
      width: mapContainer.clientWidth, // Map container width in pixels
      height: mapContainer.clientHeight, // // Map container height in pixels
    };

    const { center, zoom } = fitBounds(newBounds, size);

    this.props.setMapZoomAndCenter(center, zoom - 1);
  }

  renderProducingAssetsOnMap(producingAssets) {
    if (!producingAssets) return false;

    return producingAssets.map(asset => {
      let iconColor = '#F87733';
      const assetProducingLat = asset.gpsLatitude
        ? parseFloat(asset.gpsLatitude)
        : 48.880343;
      const assetProducingLng = asset.gpsLongitude
        ? parseFloat(asset.gpsLongitude)
        : 2.325582;
      let assetIcon;

      switch (asset.assetType) {
        case enums.AssetType.WIND_TURBINE:
          assetIcon = assets.images.windTurbineMapIcon2;
          break;
        case enums.AssetType.SOLAR_PANEL:
          assetIcon = assets.images.solarPanelMapIcon2;
          break;
        case enums.AssetType.DAM:
          assetIcon = assets.images.damMapIcon2;
          break;
        case enums.AssetType.FACTORY:
          assetIcon = assets.images.factoryMapIcon2;
          break;
        case enums.AssetType.GEOTHERMAL:
          assetIcon = assets.images.geothermalIcon;
          break;
        case enums.AssetType.SOLID_BIOMASS:
          assetIcon = assets.images.solidBiomassIcon;
          break;
        default:
          assetIcon = assets.icons.boltMapIcon2;
      }

      let tooltipContent = asset.displayedName;
      tooltipContent +=
        ' | ' + parseInt(asset.capacityWh / 1000000, 10) + ' MW';

      return (
        <div
          lat={assetProducingLat}
          lng={assetProducingLng}
          key={'producingAsset' + asset.id}
        >
          <Tooltip title={tooltipContent}>
            <div
              onClick={() => {
                switch (asset.assetType) {
                  case enums.AssetType.WIND_TURBINE:
                    asset.icon = assets.images.windTurbineMapIcon2;
                    break;
                  case enums.AssetType.SOLAR_PANEL:
                    asset.icon = assets.images.solarPanelMapIcon2;
                    break;
                  case enums.AssetType.DAM:
                    asset.icon = assets.images.damMapIcon2;
                    break;
                  case enums.AssetType.FACTORY:
                    asset.icon = assets.images.factoryMapIcon2;
                    break;
                  case enums.AssetType.GEOTHERMAL:
                    asset.icon = assets.images.geothermalIcon;
                    break;
                  case enums.AssetType.SOLID_BIOMASS:
                    assetIcon = assets.images.solidBiomassIcon;
                    break;
                  default:
                    asset.icon = assets.icons.boltMapIcon2;
                }

                console.log('displayedAsset... ', asset);
                this.setState({ displayedAsset: asset });
              }}
            >
              <Place
                style={{
                  color: '#F87733',
                  fontSize: 52,
                  position: 'absolute',
                  top: -40,
                  left: -21,
                }}
              />
              <img
                src={assetIcon}
                style={{
                  maxHeight: 19,
                  marginLeft: 19,
                  marginRight: 19,
                  marginBottom: -4,
                  position: 'absolute',
                  top: -30,
                  left: -23,
                }}
              />
            </div>
          </Tooltip>
        </div>
      );
    });
  }

  onMapLoaded({ map, maps }) {
    //this.setMapBounds(this.map, this.mapWrapper, map, maps);
  }

  togglePreferencesDialog() {
    console.log(
      'togglePreferencesDialog dialogPreferencesOpen',
      this.state.dialogPreferencesOpen
    );
    this.setState({
      dialogPreferencesOpen: !this.state.dialogPreferencesOpen,
    });
  }

  renderPreferencesDialog() {
    const { classes } = this.props;
    const assetCenter = {
      lat: 48.880343,
      lng: 2.325582,
    };
    const defaultCenter = assetCenter;
    const zoom = 5;
    const center = assetCenter;
    let fullAddress = '';
    let currentAssetProducing;
    if (this.state.displayedAsset) {
      currentAssetProducing = this.state.displayedAsset;
      let numberAndStreet = '';
      if (currentAssetProducing.houseNumber && currentAssetProducing.street) {
        numberAndStreet =
          currentAssetProducing.houseNumber +
          ' ' +
          currentAssetProducing.street +
          ', ';
      } else if (
        !currentAssetProducing.houseNumber &&
        currentAssetProducing.street
      ) {
        numberAndStreet = currentAssetProducing.street + ', ';
      } else if (
        currentAssetProducing.houseNumber &&
        !currentAssetProducing.street
      ) {
        numberAndStreet = currentAssetProducing.houseNumber + ', ';
      }

      let zipCode = currentAssetProducing.zip
        ? currentAssetProducing.zip + ', '
        : '';
      let city = currentAssetProducing.city
        ? currentAssetProducing.city + ', '
        : '';
      let region = currentAssetProducing.region
        ? currentAssetProducing.region + ', '
        : '';
      let country = currentAssetProducing.country
        ? currentAssetProducing.country
        : '';

      fullAddress = numberAndStreet + zipCode + city + region + country;
    }

    return (
      <Dialog
        fullScreen={true}
        open={this.state.dialogPreferencesOpen}
        onClose={() => {
          this.setState({
            dialogPreferencesOpen: !this.state.dialogPreferencesOpen,
          });
        }}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          Sélectionnez vos actifs de production
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Grid container spacing={12}>
              <Grid item xs={12}>
                <Row>
                  <Col xs={12} sm={6}>
                    <div
                      style={{ height: 600 }}
                      ref={mapWrapper => (this.mapWrapper = mapWrapper)}
                    >
                      {this.renderMap(defaultCenter, center, zoom)}
                    </div>
                  </Col>
                  <Col xs={12} sm={6}>
                    <Grid container spacing={12}>
                      <Grid item xs={12}>
                        {!this.state.displayedAsset && (
                          <Card className={classes.card}>
                            <CardHeader
                              title="Aucun asset sélectionné"
                              subheader="Veuillez cliquer sur un actif sur la carte"
                            />
                          </Card>
                        )}
                        {this.state.displayedAsset && currentAssetProducing && (
                          <div>
                            <CardMedia
                              className={classes.media}
                              image={
                                process.env.REACT_APP_API_URL +
                                '/static/prod_asset_' +
                                currentAssetProducing.id +
                                '.jpg'
                              }
                              title=""
                            />
                            <Card className={classes.card}>
                              <CardHeader
                                avatar={
                                  <img
                                    src={currentAssetProducing.icon}
                                    style={{ maxHeight: 20 }}
                                  />
                                }
                                title={currentAssetProducing.displayedName}
                                subheader={fullAddress}
                              />
                              <CardContent>
                                <Typography
                                  className={classes.title}
                                  color="textSecondary"
                                >
                                  <p>
                                    <span style={{ fontWeight: 'bold' }}>
                                      Capacité{' '}
                                    </span>{' '}
                                    {parseInt(
                                      currentAssetProducing.capacityWh /
                                        1000000,
                                      10
                                    )}{' '}
                                    MW
                                  </p>
                                </Typography>
                                <Typography
                                  className={classes.title}
                                  color="textSecondary"
                                >
                                  <p>
                                    <span style={{ fontWeight: 'bold' }}>
                                      {' '}
                                      Mise en service{' '}
                                    </span>{' '}
                                    1927
                                  </p>
                                </Typography>
                                <Typography
                                  className={classes.title}
                                  color="textSecondary"
                                >
                                  <p>
                                    <span style={{ fontWeight: 'bold' }}>
                                      {' '}
                                      Production annuelle{' '}
                                    </span>{' '}
                                    265 GWh
                                  </p>
                                </Typography>
                                <Typography
                                  className={classes.title}
                                  color="textSecondary"
                                >
                                  <p>
                                    <span style={{ fontWeight: 'bold' }}>
                                      Prix de l’électricité{' '}
                                    </span>{' '}
                                    EEX +{' '}
                                    {parseInt(currentAssetProducing.price, 10)}
                                    €/MWh
                                  </p>
                                </Typography>
                                <Row>
                                  <Button
                                    type="submit"
                                    variant="raised"
                                    color="primary"
                                    style={{ marginTop: 20, marginBottom: 20 }}
                                    onClick={() => {
                                      this.selectAsset(
                                        this.state.displayedAsset
                                      );
                                    }}
                                  >
                                    Ajouter cet actif
                                  </Button>
                                </Row>
                              </CardContent>
                            </Card>
                          </div>
                        )}
                        <Button
                          variant="outlined"
                          color="primary"
                          component="span"
                          className={classes.button}
                          style={{
                            marginTop: 13,
                            marginBottom: 40,
                            border: '1px solid rgba(248,119,51, 0.5)',
                            borderRadius: 4,
                          }}
                          onClick={() => {
                            this.setState({
                              dialogPreferencesOpen: !this.state
                                .dialogPreferencesOpen,
                            });
                          }}
                        >
                          Fermer
                        </Button>
                      </Grid>
                    </Grid>
                  </Col>
                </Row>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    this.state.prodAssetsList.map(pA => {});
    let newAssetsProducingList = reorder(
      this.state.prodAssetsList,
      result.source.index,
      result.destination.index
    );

    this.setState({
      prodAssetsList: newAssetsProducingList,
      loadingAssetsList: true,
    });

    setTimeout(() => {
      this.setState({ loadingAssetsList: false });
    }, 1000);
  }

  renderAssetsType() {
    const { classes } = this.props;
    return (
      <DragDropContext onDragEnd={result => this.onDragEnd(result)}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {this.state.prodAssetsList.map((pAsset, index) => {
                return (
                  <Draggable
                    key={'prod-asset-' + pAsset.assetType}
                    draggableId={'prod-asset-' + pAsset.assetType}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <Grid container spacing={24}>
                          <Grid item xs={12}>
                            <Typography
                              className={classes.title}
                              variant="subheading"
                              gutterBottom
                              color="textSecondary"
                              style={{
                                fontSize: '0.875rem',
                                float: 'left',
                                paddingTop: 8,
                              }}
                            >
                              <img
                                src={pAsset.assetTypeIcon}
                                style={{
                                  maxHeight: 16,
                                  marginLeft: 5,
                                  marginRight: 5,
                                }}
                              />{' '}
                              {pAsset.assetTypeName}
                              {index === 0 ? ' (Le plus prioritaire)' : ''}
                            </Typography>
                            <img
                              src={assets.icons.listIcon}
                              style={{
                                maxHeight: 16,
                                marginTop: 10,
                                marginLeft: 5,
                                marginRight: 5,
                                float: 'right',
                              }}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }

  renderSpecificAsset() {
    const { classes } = this.props;
    return (
      <div className={classes.wrapper}>
        <Typography
          color="inherit"
          variant="caption"
          style={{ paddingBottom: 20 }}
        >
          Mes actifs spécifiques :
        </Typography>
        <AssetsList
          loading={this.state.loadingAssetsList}
          assets={this.state.selectedAssets}
        />
      </div>
    );
  }

  render() {
    const { classes, t } = this.props;

    return (
      <div className={classes.root}>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <Card className={classes.card}>
              <CardHeader
                avatar={<img src={settingsIcon} style={{ maxHeight: 20 }} />}
                title={t('Préférences pour ma consommation')}
              />
              <CardContent>
                <div className={classes.wrapper}>
                  <ValidatorForm
                    ref="form"
                    onSubmit={() => {}}
                    onError={errors => console.log(errors)}
                    className={classNames(classes.margin, classes.textField)}
                  >
                    <Grid item xs={12}>
                      <Row xs={12} style={{ marginTop: 20, marginBottom: 40 }}>
                        <Col xs={12} sm={6}>
                          <TextValidator
                            style={{ width: 300 }}
                            label="Volume (MWh/an)"
                            onChange={event =>
                              this.setState({ volume: event.target.value })
                            }
                            name="name"
                            value={this.state.volume ? this.state.volume : 0}
                            validators={['required']}
                            errorMessages={['Le volume est requis']}
                          />
                        </Col>
                        <Col xs={12} sm={6}>
                          <DatesSlider />
                        </Col>
                      </Row>

                      <Row xs={12} style={{ marginTop: 40, marginBottom: 40 }}>
                        <PercentageSlider />
                      </Row>

                      <Row xs={12} style={{ marginTop: 40, marginBottom: 40 }}>
                        <Col xs={12} sm={6}>
                          <div className={classes.wrapper}>
                            <Typography
                              color="inherit"
                              variant="caption"
                              style={{ paddingBottom: 20 }}
                            >
                              Priorités par type d'asset de production (drag &
                              drop pour changer l'ordre) :
                            </Typography>
                            <div style={{ marginTop: 10 }}>
                              {this.renderAssetsType()}
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} sm={6}>
                          <DistanceSlider />
                        </Col>
                      </Row>

                      <Row xs={12} style={{ marginTop: 40, marginBottom: 40 }}>
                        <div
                          style={{
                            float: 'left',
                            marginTop: 10,
                            marginRight: 10,
                          }}
                        >
                          <Typography variant="body1" gutterBottom>
                            Je choisis mes actifs
                          </Typography>
                        </div>
                        <FormGroup>
                          <FormControlLabel
                            control={<BlueSwitch />}
                            onClick={() => {
                              this.setState({
                                displaySpecificAssets: !this.state
                                  .displaySpecificAssets,
                              });
                            }}
                            label="Laisser Engie tout gérer pour moi"
                          />
                        </FormGroup>
                      </Row>

                      {!this.state.displaySpecificAssets && (
                        <Row
                          xs={12}
                          style={{ marginTop: 10, marginBottom: 10 }}
                        >
                          <div style={{ float: 'left' }}>
                            <Typography variant="body1" gutterBottom>
                              Prix de l’électricité :
                            </Typography>
                            <Typography variant="h4" gutterBottom>
                              EEX + 2,00€/MWh
                            </Typography>
                            <Button
                              type="submit"
                              variant="raised"
                              color="primary"
                              style={{ marginTop: 20, marginBottom: 20 }}
                            >
                              Souscrire
                            </Button>
                          </div>
                        </Row>
                      )}

                      <CSSTransitionGroup
                        transitionName="example"
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={300}
                      >
                        {this.state.displaySpecificAssets && (
                          <Button
                            variant="outlined"
                            color="primary"
                            component="span"
                            className={classes.button}
                            style={{
                              marginTop: 13,
                              marginBottom: 40,
                              border: '1px solid rgba(248,119,51, 0.5)',
                              borderRadius: 4,
                            }}
                            onClick={() => {
                              this.setState({
                                dialogPreferencesOpen: !this.state
                                  .dialogPreferencesOpen,
                              });
                            }}
                          >
                            Sélectionner mes actifs
                          </Button>
                        )}
                        {this.state.displaySpecificAssets
                          ? this.renderSpecificAsset()
                          : false}
                        {this.state.displaySpecificAssets &&
                          this.state.selectedAssets &&
                          this.state.selectedAssets.length > 0 && (
                            <div
                              style={{
                                float: 'left',
                                marginTop: 40,
                                marginBottom: 40,
                              }}
                            >
                              <Typography variant="body1" gutterBottom>
                                Prix de l’électricité :
                              </Typography>
                              <Typography variant="h4" gutterBottom>
                                EEX + 2,00€/MWh
                              </Typography>
                              <Button
                                type="submit"
                                variant="raised"
                                color="primary"
                                style={{ marginTop: 20, marginBottom: 20 }}
                              >
                                Souscrire
                              </Button>
                            </div>
                          )}
                      </CSSTransitionGroup>
                    </Grid>
                  </ValidatorForm>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {this.renderPreferencesDialog()}
      </div>
    );
  }
}

OrganizationPreferences.contextTypes = {
  router: PropTypes.object,
};

OrganizationPreferences.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({}) => {
  return {};
};

const mapDispatchToProps = {};

OrganizationPreferences = withStyles(styles, {
  name: 'OrganizationPreferences',
})(OrganizationPreferences);
OrganizationPreferences = translate('translations')(OrganizationPreferences);
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OrganizationPreferences)
);



// WEBPACK FOOTER //
// ./src/components/Organization/OrganizationPreferences.js